// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"194":"component---src-pages-resume-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","563":"cb355538"}[chunkId] + "-" + {"194":"28f3769d5ec257b4510a","245":"2d5b0d11102e38ade4ed","453":"e2bc41f01f29c39c60db","563":"6b72bf701797cf7ecab5"}[chunkId] + ".js";
};